import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize',
  standalone: true
})
export class CapitalizePipe implements PipeTransform {
  constructor(private titleCase: TitleCasePipe) {}

  private smallWords = [
    'a', 'an', 'the',
    'and', 'but', 'or', 'nor',
    'as', 'at', 'by', 'for', 'in', 'of', 'on', 'per', 'to'
  ];

  transform(value: string): string {
    if (!value) return '';

    return value.toLowerCase().split(' ').map(ele=> {
      return this.smallWords.includes(ele)? ele.toLowerCase() :this.titleCase.transform(ele);
    }).join(' ');
  }

}
